import { render, staticRenderFns } from "./businessIndicatorsYs.vue?vue&type=template&id=4acb090c&scoped=true"
import script from "./businessIndicatorsYs.vue?vue&type=script&lang=js"
export * from "./businessIndicatorsYs.vue?vue&type=script&lang=js"
import style0 from "./businessIndicatorsYs.vue?vue&type=style&index=0&id=4acb090c&prod&lang=scss&scoped=true"
import style1 from "./businessIndicatorsYs.vue?vue&type=style&index=1&id=4acb090c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acb090c",
  null
  
)

export default component.exports